// src/api/knowledgebaseService.ts
import { apiService } from './apiService';

export const knowledgebaseService = {
  getKnowledgeBasesBySourceId: (workspaceid: string) =>
    apiService.get(`/api/KnowledgeBase/GetKnowledgeBases?knowledgeworkspaceid=${workspaceid}`, {}, 'backend'),

  getDocuments: (knowledgeBaseId: string) =>
    apiService.get('/api/KnowledgeBase/documents', { knowledgeBaseId }, 'backend'),

  downloadDocument: (id: string) =>
    apiService.get(`/api/KnowledgeBase/documents/download/${id}`, {}, 'backend'),

  deleteDocument: (id: string) =>
    apiService.delete(`/api/KnowledgeBase/documents/${id}`, 'backend'),

  deleteKnowledgeBase: (data: { knowledgeBaseId: string; tenantId: string }) =>
    apiService.post('/api/KnowledgeBase/deletekb', data, 'backend'),

  renameSource: (payload: { tenantID: string; knowledgeBaseId: string; newTitle: string }) =>
    apiService.post('/api/knowledgebase/rename', payload, 'backend'),

  createKnowledgeBase: (data: any) =>
    apiService.post('/api/KnowledgeBase/create', data, 'backend'),

  updateKnowledgeBase: (data: any) =>
    apiService.post('/api/KnowledgeBase/edit-metadata', data, 'backend'),

  uploadDocuments: (data: {
    knowledgeBaseId: string;
    tenantId: string;
    namespace?: string;
    documents?: string[];
  }) => apiService.post('/api/KnowledgeBase/add-documents', data, 'backend'),

  uploadFile: (formData: FormData) =>
    apiService.postFormData('/api/Upload/file', formData, 'backend'),

  getRolesWithUsers: () =>
    apiService.get('/api/auth/roles/users', {}, 'backend'),

  getAllUsers: () =>
    apiService.get('/api/auth/users', {}, 'backend'),

  getUploadedDocuments: async (kbId: string) =>
    apiService.get(`/api/KnowledgeBase/documents?knowledgeBaseId=${kbId}`, {}, 'backend')

};
